import * as React from "react";
// UI frameworks
import { Row, Col } from "antd";
// Styles
import styles from "./index.module.scss";

interface IProps {
	title: string;
	info: number | string | undefined;
	prefix?: "ریال" | "گرم" | string;
}

const Info: React.FC<IProps> = props => {
	return (
		<div className={styles["main"]}>
			<Row type="flex" justify="space-between">
				<Col span={6} className={styles["main__title"]}>
					{props.title}
				</Col>
				<Col span={6} className={styles["main__info"]}>
					{props.info}
					{props.prefix ? ` ${props.prefix}` : null}
				</Col>
			</Row>
		</div>
	);
};
export default Info;
